import React from 'react';
import styles from './BasePublishWebsiteModalContent.scss';

interface ModalContentProps {
  header: string;
  textContent: React.ReactNode;
  bottomContent: React.ReactNode;
}

const BasePublishWebsiteModalContent = ({ header, textContent, bottomContent }: ModalContentProps) => {
  return (
    <>
      <div
        className={styles.BasePublishWebsiteModalContent__TopContent}
        data-testid="BasePublishWebsiteModalContent__TopContent"
      >
        <h4 className={styles.BasePublishWebsiteModalContent__Header}>{header}</h4>
        <div className={styles.BasePublishWebsiteModalContent__TextContext}>{textContent}</div>
      </div>
      <div className={styles.BasePublishWebsiteModalContent__BottomContent}>{bottomContent}</div>
    </>
  );
};

export default BasePublishWebsiteModalContent;
